import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomActionDependencyContext = /*#__PURE__*/createContext(undefined);
export const CustomActionDependencyProvider = ({
  children,
  privateDependencies,
  actionDependencies = {}
}) => {
  const [_actionDependencies, _setActionDependencies] = useState(actionDependencies);
  const [_privateDependencies, _setPrivateDependencies] = useState(privateDependencies);

  // Note: Mask that we are using an useState setter from consumers.
  const handleUpdatePrivateDependencies = newDeps => _setPrivateDependencies(prevDeps => Object.assign({}, prevDeps, newDeps));

  // Note: Mask that we are using an useState setter from consumers.
  const handleUpdateActionDependencies = newDeps => _setActionDependencies(prevDeps => Object.assign({}, prevDeps, newDeps));
  return /*#__PURE__*/_jsx(CustomActionDependencyContext.Provider, {
    value: {
      actionDependencies: _actionDependencies,
      privateDependencies: _privateDependencies,
      updateActionDependencies: handleUpdateActionDependencies,
      updatePrivateDependencies: handleUpdatePrivateDependencies
    },
    children: children
  });
};
/**
 * To support class actions provide an HOC for accessing action dependencies
 * @deprecated prefer using CustomActionDependencyHooks()
 */
export function wireActionDependencies(WrappedComponent) {
  return props => {
    const context = useContext(CustomActionDependencyContext);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      actionDependencies: context === null || context === void 0 ? void 0 : context.actionDependencies
    }));
  };
}